import React from "react";
import { AbsoluteCenter } from "../../AbsoluteCenter";
import { ButtonWithSound } from "../../AudioProvider";
import { useTranslation } from "react-i18next";
import infoIcon from "../../../assets/info.svg";
import { useScreenType } from "../../../hooks/useScreenType";
import { useShop } from "../../Shop";
import { useUser, xpModalType } from "../../UserProvider";

const PopupContainer = ({ children }: { children?: React.ReactNode }) => {
  const screenType = useScreenType();

  return (
    <div className="fixed bg-black-alpha-30 top-0 left-0 right-0 bottom-0 z-50">
      {screenType === "DESKTOP" ? (
        <AbsoluteCenter>{children}</AbsoluteCenter>
      ) : (
        <div className="flex justify-center items-center h-screen">
          {children}
        </div>
      )}
    </div>
  );
};

export const RoomIsNotAvailableModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const {
    user: { balances },
    showXPModal,
  } = useUser();
  const { t } = useTranslation();
  const openShop = useShop();

  return (
    <PopupContainer>
      <div
        style={{
          width: "420px",
          background: "linear-gradient(180deg, #306DAE 0%, #063358 100%)",
          border: "1px solid #1E71D3",
          borderRadius: "20px",
          padding: "60px 32px",
        }}
        className="text-white flex flex-col items-center gap-3"
      >
        <img src={infoIcon} width={50} height={50} alt="Success" />
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-1 text-center">
            <p
              style={{
                fontSize: "20px",
                lineHeight: "30px",
                fontWeight: 500,
              }}
            >
              {showXPModal === xpModalType.lowLevel
                ? t("xp_system.not_enough_xp")
                : t("xp_system.high_xp_level")}
            </p>
            <p>
              {showXPModal === xpModalType.lowLevel
                ? t("xp_system.low_xp_level")
                : t("xp_system.xp_exceeds_limit")}
            </p>
          </div>
          <div className="flex items-center w-full gap-4 justify-center">
            {showXPModal === xpModalType.lowLevel && (
              <ButtonWithSound
                className="btn-green-500 rounded-md shadow-xl text-white w-2/5 py-1 text-sm h-7"
                onClick={() => {
                  openShop(balances[0]?.currency);
                  onClose();
                }}
              >
                {t("xp_system.go_to_shop")}
              </ButtonWithSound>
            )}
            <ButtonWithSound
              className="btn btn-gray-500 rounded-md shadow-xl text-black w-2/5 py-1 text-sm h-7"
              onClick={onClose}
            >
              {t("close")}
            </ButtonWithSound>
          </div>
        </div>
      </div>
    </PopupContainer>
  );
};
